/* „Twój plan", the plate beside the Subskrypcja tab: the crown photograph full width at the top,
 * the text under it.
 *
 * ── An ordinary card in both themes (owner, 4 November 2026) ────────────────────────────────
 * `--bg-card`, a hairline, the radius of the screen's groups, and the side cards' neutral lift. It
 * was a `--photo` slab with its own theme-independent ink until then; the slab read as a dark block
 * standing in a light theme. The crown is drained with `--filter-plate-crown`, because the
 * photograph's ember edge light is a coloured glow and this app draws none.
 *
 * ── The square at the top is part of the PLATE ──────────────────────────────────────────────
 * It is drawn whether or not there is a plaque in it — see the component. A plate that gained a
 * square when the read landed would move in its own centred column, and this screen does not move.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

.plate {
  position: relative;
  overflow: hidden;
  color: var(--text);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-account-group);
  box-shadow: var(--shadow-card);
}

/* The square. `aspect-ratio` rather than a height, so it follows the column's width and the plate
 * keeps the mockup's proportion at every viewport it survives. */
.imageBox {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 0;
  filter: var(--filter-plate-crown);
}

/* The mockup's `.plate.tall .tx`: 20 above, 22 on the sides and below. It was written as
 * `--space-5-5px`, which is 5.5 PIXELS rather than the scale's 5.5th step — so the block stood hard
 * against the plate's left edge, which is the „cramped" the owner reported. */
.text {
  padding: var(--space-20px) var(--space-22px) var(--space-22px);
}

.eyebrow {
  font-size: var(--fs-account-plate-eyebrow);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

.name {
  margin: var(--space-1) var(--space-0);
  font-size: var(--fs-account-plate-name);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-plan);
  letter-spacing: var(--ls-display);
  color: var(--text);
}

/* The mockup's `.plate p` leading, 1.45 — `body`'s own `--lh-relaxed` (1.5) is prose and grew the
 * line by a pixel, which the plate's centred column then paid for twice. */
.seats {
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

/* The two waits, drawn INSIDE the paragraphs whose line boxes are the reserve — see the component.
 * `inline-block` so each sits on its line rather than replacing it, and neither carries a margin:
 * the paragraph already owns the spacing above and below. Each bar is shorter than its line and
 * hangs from the line's top, so the line box stays the strut's own height: a bar as tall as the
 * type, centred, grew the plate by 1.6px for the length of the wait and the centred slab moved. */
.nameBar {
  display: inline-block;
  width: 62%;
  height: 0.8lh;
  vertical-align: top;
}

.seatsBar {
  display: inline-block;
  width: 48%;
  height: 0.8lh;
  vertical-align: top;
}

/* „Odnowienie · 14 listopada 2026", under a hairline: the title left, the date right. */
.renewal {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
  padding-top: var(--space-14px);
  margin-top: var(--space-14px);
  font-size: var(--fs-note);
  line-height: var(--lh-note);
  color: var(--text-2);
  border-top: var(--border-hairline) solid var(--border);
}

.renewalValue {
  color: var(--text);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.renewalBar {
  display: inline-block;
  width: 40%;
  height: var(--fs-note);
  vertical-align: middle;
}
